import { render, staticRenderFns } from "./HomestayList.vue?vue&type=template&id=1172f8e6&"
import script from "./HomestayList.vue?vue&type=script&lang=js&"
export * from "./HomestayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports